import renderPrgImage from '../source/programImg'

// export const tabs = [
//     {
//         id: 1,
//         title: 'AI Kits',
//         defaultDevice: 'pcAiTool',
//         content: [
//             {
//                 id: 'ai0',
//                 device: 'Ai0',
//                 name: 'AI 0',
//                 src: 'ai0Kit',
//                 nav: '',
//                 aiSupport: [],
//             },
//             {
//                 id: 'ai1',
//                 device: 'pcAiTool',
//                 name: 'AI 1',
//                 src: 'ai1Kit',
//                 nav: '',
//                 aiSupport: [],
//             },
//         ],
//     },

//     {
//         id: 2,
//         title: 'Codable Modules',
//         defaultDevice: 'Ace',
//         content: [
//             {
//                 id: 'moki',
//                 device: 'Moki',
//                 name: 'Moki',
//                 src: 'moki',
//                 nav: '',
//                 aiSupport: ['Ai0'],
//             },
//             {
//                 id: 'poki',
//                 device: 'Poki',
//                 name: 'Poki',
//                 src: 'tokiPlus',
//                 nav: '',
//                 aiSupport: ['Ai0'],
//             },
//             {
//                 id: 'toki',
//                 device: 'Toki',
//                 name: 'Toki',
//                 src: 'toki',
//                 nav: '',
//                 aiSupport: [],
//             },

//             {
//                 id: 'roboki',
//                 device: 'Roboki',
//                 name: 'Roboki',
//                 src: 'roboki',
//                 nav: '',
//                 aiSupport: ['pcAiTool'],
//             },
//             {
//                 id: 'ace1',
//                 device: 'Ace1',
//                 name: 'PeeCee',
//                 src: 'peeCeeB',
//                 nav: '',
//                 aiSupport: ['pcAiTool'],
//             },
//             {
//                 id: 'Ace0.1',
//                 device: 'Ace0',
//                 name: 'PeeCee v0.1',
//                 src: 'peeCeeA',
//                 nav: '',
//                 aiSupport: [],
//             },
//         ],
//     },

//     {
//         id: 3,
//         title: 'Codable Kits',
//         defaultDevice: 'Ace',
//         content: [
//             // {
//             //     id: 'tokiMakeyKit',
//             //     device: 'Toki',
//             //     name: 'Toki: Makey Kit',
//             //     src: 'tokiMakeyKit',
//             //     nav: '',
//             //     aiSupport: [],
//             // },
//             {
//                 id: 'pokiRoverKit',
//                 device: 'Poki',
//                 name: 'Rover Kit',
//                 src: 'PokiRoverKit',
//                 nav: '',
//                 aiSupport: ['Ai0'],

//                 animation: 'pokiRoverKitGlb', // thus is the glb file animation path "../../assits/08_roverkey.glb"
//                 animationSlides: 5,
//                 bytes: '',
//                 assetsList: [
//                     ['Base1', 'baseConnecter1'],
//                     ['socket2_9', 'screw7_8_11'],
//                     ['dcMotor3'],
//                     ['nut4', 'bolt4'],
//                     ['tire5'],
//                     ['poki6'],
//                     ['screw7_8_11'],
//                     ['screw7_8_11'],
//                     ['socket2_9'],
//                     ['wheel10'],
//                     ['screw7_8_11'],
//                 ],
//             },
//             {
//                 id: 'pokiExcavatorRover',
//                 device: 'Poki',
//                 name: 'Excavator Rover',
//                 src: 'pokiExcavatorRover',
//                 nav: '',
//                 aiSupport: ['Ai0'],

//                 animation: 'pokiExcavatorRoverGlb', // thus is the glb file animation path "../../assits/08_roverkey.glb"
//                 animationSlides: 5,
//                 bytes: '',
//                 assetsList: [
//                     ['Base1', 'baseConnecter1'],
//                     ['socket2_9', 'screw7_8_11'],
//                     ['wheel10', 'screw7_8_11'],
//                     ['dcMotor3'],
//                     ['nut4', 'bolt4'],
//                     ['tire5'],
//                     ['excavator1'],
//                     ['excavator2', 'nut4', 'bolt4'],
//                     ['excavatorServo', 'excavatorScrew5'],
//                     ['servoBlad'],
//                     ['excavatorMdel3', 'excavatorSide3'],
//                     ['washer4'],
//                     ['excavatorScrew5', 'nut4', 'bolt4'],
//                     ['excavatorDown6', 'excavatorUp6'],
//                     ['poki6'],
//                     ['screw7_8_11'],
//                 ],
//             },
//             {
//                 id: 'pokiRadarRover',
//                 device: 'Poki',
//                 name: 'Radar Rover',
//                 src: 'pokiRadarRover',
//                 nav: '',
//                 aiSupport: ['Ai0'],

//                 animation: 'pokiRadarRoverGlb', // thus is the glb file animation path "../../assits/08_roverkey.glb"
//                 animationSlides: 5,
//                 bytes: '',
//                 assetsList: [
//                     ['Base1', 'baseConnecter1'],
//                     ['socket2_9', 'screw7_8_11'],
//                     ['dcMotor3'],
//                     ['nut4', 'bolt4'],
//                     ['tire5'],
//                     ['poki6'],
//                     ['screw7_8_11'],
//                     ['screw7_8_11'],
//                     ['socket2_9'],
//                     ['wheel10'],
//                     ['screw7_8_11'],
//                     ['excavatorServo', 'socketNut2', 'bolt4'],
//                     ['servoBlad', 'screw7_8_11'],
//                     ['radar2', 'excavatorScrew5'],
//                     ['servoBlad', 'screw7_8_11', 'bolt4'],
//                     ['radarUltraSonic'],
//                     ['screw7_8_11', 'bolt4'],
//                 ],
//             },
//             {
//                 id: 'pokiGripperRover',
//                 device: 'Poki',
//                 name: 'Gripper Rover',
//                 src: 'pokiGripperRover',
//                 nav: '',
//                 aiSupport: ['Ai0'],

//                 animation: 'pokiGripperRoverGlb', // thus is the glb file animation path "../../assits/08_roverkey.glb"
//                 animationSlides: 5,
//                 bytes: '',
//                 assetsList: [
//                     ['Base1', 'baseConnecter1'],
//                     ['socket2_9', 'screw7_8_11'],
//                     ['poki6'],
//                     ['screw7_8_11'],
//                     ['dcMotor3'],
//                     ['nut4', 'bolt4'],
//                     ['tire5'],
//                     ['socket2_9', 'screw7_8_11'],
//                     ['wheel10', 'screw7_8_11'],
//                     ['excavatorServo', 'excavator2'],
//                     ['screw7_8_11'],
//                     ['excavatorScrew5'],
//                     ['servoBlad', 'gripper1'],
//                     ['gripper2'],
//                     ['screw7_8_11'],
//                     ['screw7_8_11', 'excavatorScrew5', 'bolt4'],
//                     ['gripper3'],
//                     ['excavatorServo'],
//                     ['bolt4'],
//                     ['screw7_8_11'],
//                     ['servoBlad', 'socket2_9'],
//                     ['gripper4', 'gripper5'],
//                     ['screw7_8_11', 'excavatorScrew5'],
//                 ],
//             },

//             // {
//             //     id: 'pokiPetBot',
//             //     device: 'Poki',
//             //     name: 'Poki Pet Bot',
//             //     src: 'PokiPetBotKit',
//             //     nav: '',
//             //     aiSupport: ['Ai0'],
//             // },
//             // {
//             //     id: 'pokiWalkerBot',
//             //     device: 'Poki',
//             //     name: 'Poki: Walker Bot',
//             //     src: 'PokiWalkerBotKit',
//             //     nav: '',
//             //     aiSupport: ['Ai0'],
//             // },
//             // {
//             //     id: 'pokiRoboticArm',
//             //     device: 'Poki',
//             //     name: 'Poki: Robotic Arm',
//             //     src: 'PokiRoboticArmKit',
//             //     nav: '',
//             //     aiSupport: ['Ai0'],
//             // },
//             // {
//             //     id: 'mokiSpider',
//             //     device: 'Moki',
//             //     name: 'Moki: Spider',
//             //     src: 'MokiSpiderKit',
//             //     nav: '',
//             //     aiSupport: ['Ai0'],
//             // },
//             // {
//             //     id: 'mokiATR',
//             //     device: 'Moki',
//             //     name: 'Moki: ATR',
//             //     src: 'MokiATRKit',
//             //     nav: '',
//             //     aiSupport: ['Ai0'],
//             // },
//             // {
//             //     id: 'mokiQuadrover',
//             //     device: 'Moki',
//             //     name: 'Moki: Quadrover',
//             //     src: 'MokiQuadroverKit',
//             //     nav: '',
//             //     aiSupport: ['Ai0'],
//             // },
//         ],
//     },

//     {
//         id: 4,
//         title: 'Animatronics',
//         defaultDevice: 'Humanoid',
//         content: [
//             {
//                 id: 'klawb',
//                 device: 'Klaw',
//                 name: 'Klaw-b',
//                 src: 'klaw',
//                 nav: '',
//                 aiSupport: ['pcAiTool'],
//             },
//             {
//                 id: 'crawle',
//                 device: 'Hexapod',
//                 name: 'Crawl-e',
//                 src: 'crawle',
//                 nav: '',
//                 aiSupport: ['pcAiTool'],
//             },
//             {
//                 id: 'zing',
//                 device: 'Humanoid',
//                 name: 'Zing',
//                 src: 'zing',
//                 nav: '',
//                 aiSupport: ['pcAiTool'],
//             },
//         ],
//     },

//     {
//         id: 5,
//         title: 'RoboticKits',
//         defaultDevice: 'Atr',
//         content: [
//             {
//                 id: 'ATRkit',
//                 device: 'Atr',
//                 name: 'Atr',
//                 src: 'ATRkit',
//                 nav: '',
//                 aiSupport: ['pcAiTool'],
//             },
//         ],
//     },

//     {
//         id: 6,
//         title: 'Electronics',
//         defaultDevice: 'Trons',
//         content: [
//             {
//                 id: 'trons',
//                 name: 'Playtrons',
//                 src: 'trons',
//                 nav: 'https://playtrons.plode.org/projects',
//                 aiSupport: [],
//             },
//             {
//                 id: 'tronix',
//                 name: 'Playtronix',
//                 src: 'tronix',
//                 nav: 'https://playtronix.plode.org/',
//                 aiSupport: [],
//             },
//         ],
//     },

//     {
//         id: 7,
//         title: 'Mechanical',
//         defaultDevice: 'Trons',
//         content: [
//             {
//                 id: 'kitSelectionDynamex',
//                 name: 'Playdynamex',
//                 src: 'kitSelectionDynamex',
//                 nav: 'https://plode.org/play/#/playdynamex',
//                 aiSupport: [],
//             },
//         ],
//     },
// ]

export const tabs = [
    {
        id: 1,
        title: 'Codable Boards',
        defaultDevice: 'Ace',
        content: [
            {
                device: 'Moki',
                name: 'Moki',
                src: 'moki',
                nav: '',
            },
            {
                device: 'Toki',
                name: 'Toki',
                src: 'toki',
                nav: '',
            },
            {
                device: 'Poki',
                name: 'Poki',
                src: 'poki',
                nav: '',
            },
            {
                device: 'Roboki',
                name: 'Roboki',
                src: 'roboki',
                nav: '',
            },
            {
                device: 'Ace1',
                name: 'PeeCeeTed',
                src: 'peeCeeB',
                nav: '',
            },

            {
                device: 'Ace0',
                name: 'PeeCeeTed v0.1',
                src: 'peeCeeA',
                nav: '',
            },
        ],
    },
    {
        id: 2,
        title: 'Codable Kits',
        defaultDevice: 'Toki',
        content: [],
    },
    {
        id: 3,
        title: 'Expansion Kits',
        defaultDevice: 'Toki',
        content: [],
    },
    {
        id: 4,
        title: 'Animatronics',
        defaultDevice: 'Humanoid',
        content: [
            {
                device: 'Klaw',
                name: 'Klaw-b',
                src: 'klaw',
                nav: '',
            },
            {
                device: 'Hexapod',
                name: 'Crawl-e',
                src: 'crawle',
                nav: '',
            },
            {
                device: 'Humanoid',
                name: 'Zing',
                src: 'zing',
                nav: '',
            },
        ],
    },
    {
        id: 5,
        title: 'RoboticKits',
        defaultDevice: 'Atr',
        content: [
            {
                device: 'Atr',
                name: 'Atr',
                src: 'ATRkit',
                nav: '',
            },
        ],
    },
    {
        id: 6,
        title: 'Electronics',
        defaultDevice: 'Trons',
        content: [
            {
                device: 'Trons',
                name: 'Playtrons',
                src: 'trons',
                nav: 'https://playtrons.plode.org/projects',
            },
            {
                device: 'Tronix',
                name: 'Playtronix',
                src: 'tronix',
                nav: 'https://playtronix.plode.org/',
            },

            // {
            //     name: 'Plode X',
            //     src: 'plodeX',
            //     nav: 'https://plodex.plode.org/workspace',
            // },
        ],
    },
    {
        id: 7,
        title: 'Mechanical',
        defaultDevice: 'Trons',
        content: [
            {
                device: 'Dynamex',
                name: 'Dynamex',
                src: 'kitSelectionDynamex',
                nav: 'https://edu.plode.org/play/#/playdynamex/select?kit=kit_1',
            },
            {
                device: 'Dynamex-2',
                name: 'Dynamex-2',
                src: 'playdynamex_2',
                nav: '/playdynamex-main',
            },
            {
                device: 'Mex',
                name: 'Mex',
                src: 'playmex',
                nav: '/playmex-main',
            },
            // {
            //     name: 'Plode X',
            //     src: 'plodeX',
            //     nav: 'https://plodex.plode.org/workspace',
            // },
        ],
    },
]

export const codableKits = [
    'pokiRoverKit',
    'pokiExcavatorRover',
    'pokiRadarRover',
    'pokiGripperRover',
]
